import $ from "jquery";
import jQuery from "jquery";

/* export for others scripts to use */
window.$ = $;
window.jQuery = jQuery;

$('.ajax').on('submit', function () {
    var $form = $(this);
    var $btn = $form.find('button');

    $form.find('span.error').remove();

    $btn.prop('disabled', true);
    console.log($form.serializeArray());
    $.post($form.attr('action'), $form.serializeArray(), function () {
        $form.addClass('success');
    }).fail(function (r) {
        $.each(r.responseJSON, function (index, value) {
            $form.find('[name="' + index + '"]')
                .closest('.list')
                .append('<br><span class="error">' + value[0] + '</span>');
        });
        console.log("error");
    }).success(function (r) {
        console.log("het is helukt!!")
    });


});

$(function () {
    $('.leesmeer').each(function () {
        var $this = $(this);
        $this.on('click', function () {
            $this.closest('.vacature_holder').addClass('opened');
        })
    });


    var $vacature = $('.vacature-post');

    $vacature.on('submit', function () {
        console.log($vacature.hasClass('success'));
        if (!$vacature.hasClass('success')) {
            $.post($vacature.attr('action'), $vacature.serializeArray(), function (response) {
                if (response.success) {
                    $vacature.addClass('success');
                    $vacature.find('.verstuur').remove();
                }
            }).fail(function (r) {
                for (var i in r.responseJSON) {
                    console.log(i);
                    $vacature.find('[name=' + i + ']').addClass('has-error')
                }

                // show error
                $vacature.find('.field').each(function () {
                    var el = $(this);

                    if (el.find('.has-error')) {
                        el.find('.error').css('display', 'inline');
                    }
                })
            });
            return false;
        }
    });

});


import {FormFilterClass} from './FormFilterClass'

new FormFilterClass({
    form: document.getElementById('webshopfilter'),
    container: document.getElementById('ajax-results'),
    loader: document.getElementById('append_loader')
});


$('input[name="categories[]"]').on('change', function () {
    if ($('input[name="categories[]"]:checked').length > 0) {
        $('.vacature_cat').addClass('checked');
    } else {
        $('.vacature_cat').removeClass('checked');
    }
});

require('js-info-bubble/src/infobubble.js');
(function Maps() {

    let element = $('#opdrachtgevers_map');

    if (element.length) {
        let infoBubble
        let markerList = [];

        console.log();
        let data = element.data('maps');
        let maps_icon = element.data('icon');
        let legendItem = $('.maps_filter li');

        let map, marker;
        let bounds = new google.maps.LatLngBounds();
        let maps = document.getElementById('opdrachtgevers_map');
        let zoom = maps.getAttribute('data-zoom');
        let center = maps.getAttribute('data-center').split(',');
        map = new google.maps.Map(document.getElementById('opdrachtgevers_map'), {
            center: {
                lat: 52.3044375,
                lng: 5.3096762
            },
            zoom: 8
        });
        infoBubble = new InfoBubble({
            map: map,
            shadowStyle: 0,
            padding: 10,
            minWidth: 225,
            maxWidth: 250,
            maxHeight: 150,
            minHeight: 150,
            backgroundColor: '#ffffff',
            borderRadius: 10,
            arrowSize: 10,
            borderWidth: 1,
            borderColor: '#8695a5',
            disableAutoPan: false,
            hideCloseButton: true,
            arrowPosition: 50,
            backgroundClassName: 'gmaps-popup',
            arrowStyle: 0,
            // closeImage: 'https://maps.gstatic.com/mapfiles/api-3/images/mapcnt6.png'
        });

        for (let i = 0; i < legendItem.length; i++) {
            legendItem[i].addEventListener('click', function (e) {
                e.preventDefault();
                let gmapsID = this.getAttribute('data-gmaps-id');
                if (this.className != 'active') {
                    closePopup();
                    google.maps.event.trigger(markerList[gmapsID], 'click');
                } else {
                    closePopup();
                    this.className = ''
                }
            });
        }
        window.removeLegendClasses = function () {
            for (var i = 0; i < legendItem.length; i++) {
                legendItem[i].className = '';
            }
        };

        for (let i = 0; i < data.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(data[i].lat, data[i].lng),
                map: map,
                animation: google.maps.Animation.DROP,
                id: i
            });


            google.maps.event.addListener(marker, 'click', (function (marker, i) {

                return function () {
                    if (document.querySelector('.maps_filter li[data-gmaps-id="' + marker.id + '"]').className != 'active') {
                        let contentString = `<div class="gmaps-popup-content ' + data[i].categorie + '">
                                        <a class="close-btn" onclick="closePopup();">
                                            X
                                        </a>
                                                                                
                                        <p class="info">
                                            <span>
                                                School : 
                                            </span>
                                            <span>
                                                ` + data[i]['name'] + `
                                            </span>
                                        </p>
                                        
                                        <p class="info">
                                            <span>
                                                Website : 
                                            </span>
                                            <span>
                                                <a href="` + data[i]['website'] + `" target="_blank">` + data[i]['website'] + `</a>
                                            </span>
                                        </p>
                                        
                                         <p class="info">
                                            <span>
                                                Adres : 
                                            </span>
                                            <span>
                                                ` + data[i]['street'] + `,
                                                 ` + data[i]['zipcode'] + `
                                                 ` + data[i]['adres'] + `
                                            </span>
                                        </p>
                                        
                                      
                                         <p class="info">
                                            <span>
                                                Aantal vacatures : 
                                            </span>
                                            <span>
                                                ` + data[i]['amount'] + `
                                            </span>
                                        </p>
                                        
                                      
                                        

                                    </div>
                                      <p class="knop__wrapper">
                                          <a class="knop" href=" ` + data[i]['href'] + `">
                                              Bekijken
                                            </a>
                                        </p>
`;
                        infoBubble.setContent(contentString);
                        infoBubble.open(map, marker);
                        if (document.querySelector('.maps_filter li[data-gmaps-id="' + marker.id + '"]').className != 'active') {
                            removeLegendClasses();
                            document.querySelector('.maps_filter li[data-gmaps-id="' + marker.id + '"]').className = 'active';
                        } else {
                            removeLegendClasses();
                        }
                    }
                }

            })(marker, i));
            markerList.push(marker);

        }
        google.maps.event.addListener(map, "click", function () {
            closePopup();

        });


        window.closePopup = function () {
            infoBubble.close();
            removeLegendClasses();
            // for (var i = 0; i < legendItem.length; i++) {
            //     legendItem[i].className = '';
            // };
        }
    }

// Read a page's GET URL variables and return them as an associative array.
    function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    var loc = getUrlVars()["loc"];

    if (loc) {
        setTimeout(function () {
            var loca = document.querySelector("[data-loc-id='" + loc + "']");
            loca.click();
        }, 1000)
    }

})
();